import { createAsyncActionTypes } from '../../util/createLifeomicActionTypes';

const asyncActionTypes = createAsyncActionTypes([
  'FETCH_LAYOUTS',
  'UPDATE_LAYOUT',
  'DELETE_LAYOUT',
  'CREATE_LAYOUT',
]);

export default {
  ...asyncActionTypes,
};
